import React from "react";
import { Snackbar, Button } from "@mui/material";
import { Translate } from "react-localize-redux";
import { useRegisterSW } from "virtual:pwa-register/react";

// How often (ms) to ask the browser to re-check for a newer service worker.
// Without this, a tab left open for a long time would never notice a deploy
// until it was fully closed and reopened.
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000; // 1 hour

/**
 * Shows a non-intrusive "new version available" snackbar after a new build is
 * deployed. The reload is user-driven on purpose: clinicians are often mid-form,
 * and an automatic reload (the old registerType: 'autoUpdate') would silently
 * discard their unsaved input. Pairs with registerType: 'prompt' in vite.config.js.
 */
export default function ReloadPrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (registration) {
        setInterval(() => {
          registration.update();
        }, UPDATE_CHECK_INTERVAL_MS);
      }
    },
  });

  return (
    <Snackbar
      open={needRefresh}
      message={<Translate id="pwa.update-available" />}
      action={
        <>
          <Button
            color="primary"
            size="small"
            onClick={() => updateServiceWorker(true)}
          >
            <Translate id="pwa.reload" />
          </Button>
          <Button
            color="inherit"
            size="small"
            onClick={() => setNeedRefresh(false)}
          >
            <Translate id="pwa.dismiss" />
          </Button>
        </>
      }
    />
  );
}
